module.exports = __webpack_public_path__ + "img/role.6ee7fa1b.svg";